import { useState } from "react";
import { Card, Modal } from "antd";

function PdfMessage({ url, name }) {
  const [open, setOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleOpen = async () => {
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      setPreviewUrl(objectUrl);
      setOpen(true);
    } catch (err) {
      console.error("Failed to load PDF:", err);
    }
  };

  return (
    <>
      <Card
        size="small"
        style={{
          maxWidth: 220,
          borderRadius: 8,
          cursor: "pointer",
        }}
        onClick={handleOpen}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span role="img" style={{ fontSize: 20 }} aria-label="pdf">
            📄
          </span>
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "160px",
              display: "inline-block",
            }}
          >
            {name}
          </span>
        </div>
      </Card>

      <Modal
        title={name}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width="85%"
        bodyStyle={{ height: "80vh", padding: 15 }}
      >
        {previewUrl && (
          <iframe
            src={previewUrl}
            title="pdf-preview"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        )}
      </Modal>
    </>
  );
}

export default PdfMessage;
